import React from 'react'
import styled from 'styled-components'
import { LocalForm } from 'react-redux-form'

import AddButton from 'components/add-button'
import {
  StyledTextInput,
  StyledTextInputProps,
} from 'components/form-components/styled-text-input'
import { StyledTextArea } from 'components/form-components/styled-text-area'

interface SingleInputFormProps extends StyledTextInputProps {
  formModel: string
  isLoading: boolean
  isTextArea?: boolean
  initialState: any
  getDispatch: (dispatch: any) => void
  onClick: (form: any) => void
}

const StyledInputWrapper = styled.div`
  display: flex;
  position: relative;
  border-collapse: separate;
`

export const SingleInputForm = ({
  isLoading,
  onClick,
  initialState,
  getDispatch,
  formModel,
  isTextArea = false,
  ...props
}: SingleInputFormProps) => (
  <LocalForm
    model={formModel}
    initialState={initialState}
    getDispatch={getDispatch}
    onSubmit={form => onClick(form)}
  >
    <StyledInputWrapper>
      {isTextArea ? (
        <StyledTextArea {...props} />
      ) : (
        <StyledTextInput {...props} />
      )}
      <AddButton
        height={isTextArea && '100%'}
        variant="secondary"
        loading={isLoading}
      />
    </StyledInputWrapper>
  </LocalForm>
)
